import { HStack, IconButton, Td, Tr, useToast } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { FaPen, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { MenuLocationsContext } from '../../../../hooks/useMenuItemsLocation';

interface Props {
  location: any;
  onDelete?: (locationId: any) => void;
  onEditClick?: (location: any) => void;
}

const Item: React.FC<Props> = ({ location, onDelete, onEditClick }) => {
  const toast = useToast();
  const { t } = useTranslation();
  const { deleteLocation, loading } = useContext(MenuLocationsContext);

  const handleDelete = async (locationId: string) => {
    try {
      if (window.confirm(t('askDeleteItem'))) {
        deleteLocation(locationId);
        toast({
          title: t('success'),
          description: t('itemDeleted'),
          status: 'success',
          position: 'top-right',
        });
        if (onDelete) {
          onDelete(locationId);
        }
      }
    } catch (err: any) {
      toast({
        title: 'Opss!!',
        description:
          err?.response?.data?.message || err?.message || t('generalError'),
        status: 'error',
        position: 'top-right',
      });
    }
  };

  return (
    <>
      <Tr bg="#fff">
        <Td>{location?.name}</Td>
        <Td>{location?.slug}</Td>
        <Td>
          <HStack spacing={3}>
            <IconButton
              color="#CECECE"
              aria-label="edit-page"
              rounded="md"
              icon={<FaPen size={17} />}
              size="xs"
              colorScheme="#FFFFFF"
              isLoading={loading}
              onClick={() => {
                if (onEditClick) {
                  onEditClick(loading);
                }
              }}
            />
            <IconButton
              aria-label="delete-page"
              rounded="md"
              color="#FF6565"
              icon={<FaTrash size={17} />}
              size="xs"
              colorScheme="#FFFFFF"
              isLoading={loading}
              onClick={() => {
                handleDelete(location?.id);
              }}
            />
          </HStack>
        </Td>
      </Tr>
    </>
  );
};

export default Item;
